export const SmoothScroll = () => {
	const anchorLinks = document.querySelectorAll('a[href^="#"]:not([href="#"])');

	document.querySelectorAll('a[href="#"]').forEach(link => {
		link.addEventListener('click', e => {
			e.preventDefault();
		});
	});

	const getOffset = () => {
		const isMobile = window.innerWidth < 720;
		return isMobile ? 45 : 32;
	};

	const goTo = (target) => {
		let scrollPos;

		if (typeof target === 'number') {
			scrollPos = target;
		} else {
			const element = document.getElementById(target.replace('#', ''));
			if (!target || !element) return;
			scrollPos = element.getBoundingClientRect().top + window.scrollY;
		}

		scrollPos -= getOffset();

		window.scrollTo({
			top: scrollPos,
			behavior: 'smooth'
		});
	};

	if (window.location.hash) {
		setTimeout(() => {
			goTo(window.location.hash);
		}, 500);
	}

	anchorLinks.forEach(link => {
		link.addEventListener('click', (e) => {
			const targetId = link.hash.slice(1);
			if (!document.getElementById(targetId)) return;
			e.preventDefault();
			goTo(link.hash);
		});
	});
};
